<template>
  <v-list-item @click="develop">
    <v-list-item-avatar>
      <v-icon small :class="{ 'secondary': isDeveloping }">{{ isDeveloping ? 'fal fa-toggle-on' : 'fal fa-toggle-off' }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>DEVモード</v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'dev-toolkit',
  methods: {
    develop: function () {
      this.$store.commit('author/develop', !this.$store.getters['author/get']('dev'))
    }
  },
  computed: {
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    }
  }
}
</script>
